//#region ../icons/dist/html/scaffold/speech.js
const speechIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" fill=\"none\" aria-hidden=\"true\" viewBox=\"0 0 18 18\"><g stroke=\"currentColor\"><circle cx=\"5.5\" cy=\"8\" r=\"2\"/><path d=\"M1.5 15.5a4 4 0 0 1 8 0\"/><circle cx=\"13.5\" cy=\"5\" r=\"3\"/><path d=\"m11 8-1.5 2.5\"/></g></svg>";
//#endregion
export { speechIcon };

//# sourceMappingURL=speech.js.map